const currencies = {
	'KG': 'usd',
	'AL': 'usd',
	'XK': 'usd',
	'GE': 'rub',
	'DE': 'usd',
	'GR': 'usd',
	'KZ': 'rub',
	'PT': 'usd',
	'UZ': 'rub',
	'EE': 'usd',
	'LV': 'usd',
	'PL': 'usd',
	'MD': 'rub',
	'UA': 'rub',
	'FR': 'usd',
	'RO': 'usd',
	'ES': 'usd',
	'TH': 'usd',
	'LT': 'usd',
	'IT': 'usd',
	'HN': 'usd',
	'SV': 'usd',
	'RU': 'rub',
	'AM': 'rub',
	'HU': 'usd',
	'CY': 'usd',
	'BY': 'rub',
	'AZ': 'rub',
	'BG': 'usd',
	'SI': 'usd',
	'SK': 'usd',
	'CZ': 'usd',
	'AT': 'usd',
	'HR': 'usd',
	'NL': 'usd',
	'BE': 'usd',
	'LU': 'usd',
	'SG': 'usd',
	'CD': 'usd',
	'ZA': 'usd',
	'RW': 'usd',
	'GB': 'usd',
	'US': 'usd',
	'CA': 'usd',
	'AR': 'usd',
	'MX': 'usd',
	'VN': 'usd',
	'ID': 'usd',
	'MY': 'usd',
	'LB': 'usd',
	'AE': 'usd',
	'SA': 'usd',
	'CL': 'usd',
	'CO': 'usd',
	'IN': 'usd',
	'BD': 'usd',
	'TW': 'usd',
	'MM': 'usd',
	'PH': 'usd',
	'KW': 'usd',
	'JO': 'usd',
	'BH': 'usd',
	'NG': 'usd'
};

export default currencies;



// WEBPACK FOOTER //
// ./frontend/shared/js/geo-currency_relations.js